<template>
  <content-loader :height="300" preserveAspectRatio="none">
    <rect x="0" y="40" rx="4" ry="4" width="300" height="30" />
    <rect x="0" y="120" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="170" rx="4" ry="4" width="400" height="20" />
    <rect x="0" y="220" rx="4" ry="4" width="400" height="20" />
  </content-loader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader'

export default {
  name: "news-loading-skeleton",
  components: { ContentLoader }
}
</script>

<style scoped>
</style>